export default {
  "code": "it",
  "title": "Italiano",
  "flag": "🇮🇹",
  "meta": {
    "index": {
      "title": "Migliori lavori accademici.\n10 volte più veloce con l'IA.",
      "description": "Senza Hesse: Guardi una pagina vuota per ore.\nCon Hesse: Generi testi eccellenti con un clic."
    },
    "profile": {
      "title": "Impostazioni del profilo",
      "description": "Controlla facilmente le impostazioni del tuo profilo"
    }
  },
  "templates": {
    "summarize-text": {
      "headline": "",
      "description": ""
    },
    "find-topic": {
      "headline": "Trova argomento",
      "description": "Brainstorming per ottenere più idee per un argomento di lavoro accademico."
    },
    "find-sources": {
      "headline": "Trova fonti",
      "description": "Cerca fonti accademiche che potrebbero essere rilevanti per l'argomento."
    },
    "source-qa": {
      "headline": "Chat delle fonti",
      "description": "Rispondi a domande su una fonte. Aggiungi un link a un sito web, un documento online, o carica un file dal tuo computer."
    },
    "write-outline": {
      "headline": "Crea schema",
      "description": "Crea uno schema approssimativo per un argomento di lavoro accademico."
    },
    "write-introduction": {
      "headline": "Scrivi introduzione",
      "description": "Crea un'introduzione per un lavoro accademico."
    },
    "write-chapter": {
      "headline": "Scrivi capitolo",
      "description": "Scrivi un capitolo per un lavoro accademico."
    },
    "write-essay": {
      "headline": "Scrivi saggio",
      "description": "Scrivi un lavoro accademico completo."
    },
    "proofreading": {
      "headline": "Correzione",
      "description": "Correggi un testo."
    },
    "freestyle": {
      "headline": "Freestyle",
      "description": "Scrivi qualsiasi testo."
    },
    "summarize-document": {
      "headline": "",
      "description": ""
    },
    "summarize-article": {
      "headline": "",
      "description": ""
    },
    "summarize-source": {
      "headline": "",
      "description": ""
    }
  },
  "validations": {
    "required": "{_field_} è un campo obbligatorio",
    "min": "{_field_} deve contenere almeno {length} caratteri",
    "max": "{_field_} non deve superare {length} caratteri"
  },
  "buttons": {
    "close": "Chiudi",
    "upgrade": "aggiorna",
    "get_more_words": "Ottieni più parole ora",
    "login": "accedi",
    "logout": "esci",
    "cancel": "Annulla",
    "yes": "Sì",
    "no": "No",
    "tryout": "prova",
    "add": "aggiungi",
    "report": "segnala",
    "save": "salva",
    "edit": "modifica",
    "copy": "copia",
    "delete": "elimina",
    "generate": "genera",
    "signup": "registrati",
    "continue": "continua",
    "submit": "invia",
    "add_source": "Aggiungi fonte",
    "select_source": "Seleziona fonte",
    "new_document": "Nuovo Documento",
    "back": "indietro",
    "local_document": {
      "title": "Documento PDF dal mio computer",
      "type": "Carica documento PDF"
    },
    "web_document": {
      "title": "Link web, ad esempio Wikipedia",
      "type": "Aggiungi link web"
    },
    "done": "fatto",
    "discard": "scarta",
    "ask": "Chiedi",
    "flag": "Segnala"
  },
  "labels": {
    "missing_subscription": "Hai bisogno di un abbonamento per usare questo strumento.",
    "booked": "il tuo piano attuale",
    "account": "Account",
    "subscription": "Abbonamento",
    "name": "Nome",
    "email": "Email",
    "limit": "Limite",
    "settings": "Impostazioni",
    "words": "Parole",
    "usage": "Utilizzo",
    "extra_words": "incluso {words} parole extra",
    "show_all_applications": "Mostra tutte le applicazioni",
    "show_all": "Mostra tutto",
    "start_page": "Vai alla pagina iniziale",
    "is_favorite": "Nei preferiti",
    "add_favorite": "Aggiungi ai preferiti",
    "wordlimit_reached": "Limite di parole raggiunto",
    "wordlimit_increase": "Aumenta limite di parole ora",
    "contact": "Apri contatto",
    "history": "Cronologia",
    "show_history": "mostra cronologia",
    "inprint": "Note legali",
    "dataregulation": "Protezione dati",
    "tos": "Termini di servizio",
    "month": "mese",
    "cancel_anytime": "Cancella in qualsiasi momento",
    "try_now": "prova gratis ora",
    "book_again": "Prenota di nuovo",
    "book": "Cambia piano",
    "upgrade_to": "Aggiorna a {product}",
    "copied_link": "Link copiato",
    "subject": "Oggetto",
    "generated_by_hesse": "Generato da Hesse in 3 secondi.",
    "use_template": "usa modello",
    "show_mode": "mostra di più",
    "upload": "carica",
    "optional": "opzionale",
    "my_documents": "I Miei Documenti",
    "my_sources": "Le Mie Fonti",
    "add_source": "Aggiungi fonte",
    "select_source": "Seleziona fonte",
    "page": "Pagina {page}",
    "pages": "Pagine {from} - {to}",
    "unknown_author": "Autore sconosciuto",
    "checker_results": "Risultati del rilevatore IA",
    "human": "umano",
    "citation_style": "Stile di citazione",
    "started_at": "iniziato il",
    "ends_at": "finisce il",
    "cancel_subscription": "cancella abbonamento",
    "file_too_large": "File troppo grande (max. 50 MB), prova a dividerlo",
    "relevance": "Rilevanza",
    "relevance_help": "La rilevanza misura quanto bene la fonte si adatta all'argomento cercato in termini di contenuto.",
    "quality": "Qualità",
    "quality_help": "La qualità misura quanto è buona la fonte sia nel contenuto che nella forma.",
    "trustworthiness": "Affidabilità",
    "trustworthiness_help": "L'affidabilità misura, principalmente basandosi sui metadati della fonte, quanto è affidabile.",
    "high": "alta",
    "normal": "normale",
    "low": "bassa",
    "features": "Funzionalità",
    "monthly": "Mensile",
    "year": "anno",
    "yearly": "Annuale",
    "save_50": "risparmia 50%",
    "pay_amount_per_period": "Paga {amount}/{period}.",
    "focus_of_the_chapter": "Focus del capitolo",
    "reason": "Motivo",
    "summary": "Riassunto",
    "raw_text": "Testo grezzo",
    "topic": "Argomento",
    "essay_banner_part_1": "🚨 <i>Questa funzione sarà disabilitata presto</i><br/>Per <strong>migliori risultati di generazione</strong> e <strong>più controllo granulare</strong>, raccomandiamo di usare lo strumento",
    "essay_banner_part_2": "e generare il tuo saggio <strong>capitolo per capitolo</strong>. Provalo per un'esperienza di scrittura più fluida e personalizzata! ✨📖",
    "language": "Lingua",
    "language_english_hint": "Molti articoli accademici vengono pubblicati in inglese. Ti consigliamo di cercare anche fonti in inglese per trovare più risultati pertinenti.",
    "length": "Lunghezza",
    "length_options": [
      {
        "text": "breve (4 paragrafi)",
        "value": "short"
      },
      {
        "text": "normale (6 paragrafi)",
        "value": "normal"
      },
      {
        "text": "lungo (8 paragrafi)",
        "value": "long"
      }
    ],
    "source_type_options": [
      {
        "label": "Ricerca fonti automatica",
        "value": "quality"
      },
      {
        "label": "Lavora con le tue fonti",
        "value": "quality_with_sources"
      }
    ],
    "sources": "Fonti",
    "source": "Fonte",
    "open_access": "Accesso aperto",
    "show_only_open_access": "Mostra solo fonti ad accesso aperto",
    "essay_outline_options": [
      {
        "value": "generate",
        "label": "Genera uno schema per me"
      },
      {
        "value": "provide",
        "label": "Usa il mio schema"
      }
    ],
    "your_outline": "Il tuo schema",
    "year_of_publication": "Anno di pubblicazione",
    "outline": "Schema",
    "summary_type": "Tipo di riassunto",
    "summary_type_options": [
      {
        "label": "Informativo",
        "value": "informative"
      },
      {
        "label": "Descrittivo",
        "value": "descriptive"
      },
      {
        "label": "Critico",
        "value": "critical"
      },
      {
        "label": "Abstract",
        "value": "abstract"
      }
    ],
    "original_text": "Testo originale",
    "maintenance": "I nostri servizi sono in manutenzione per un momento. Scusaci per l'inconveniente e grazie per la comprensione!",
    "something_wrong": "Controlla sempre le citazioni. Qualcosa non va?",
    "bad_citation_title": "Segnala citazione",
    "bad_citation_text": "Dicci cosa pensi che non vada con la citazione che hai segnalato.",
    "thanks_for_report": "Grazie per aiutarci a migliorare Hesse AI!",
    "no_sources_found": "Nessuna fonte trovata. Prova a modificare l'argomento o i filtri di ricerca.",
    "user_instruction": "Istruzioni personalizzate",
    "document": "Documento",
    "article": "Articolo",
    "study_program": "Programma di studi",
    "study_subject": "Materia",
    "interests": "Interessi",
    "used_for_source_search": "Usato per la ricerca di fonti",
    "not_used_for_source_search": "Non usato per la ricerca di fonti",
    "headline": "Focus del capitolo",
    "chapter_length": "Lunghezza",
    "chapter_length_options": [
      {
        "text": "breve (4 paragrafi)",
        "value": "short"
      },
      {
        "text": "normale (6 paragrafi)",
        "value": "normal"
      },
      {
        "text": "lungo (8 paragrafi)",
        "value": "long"
      }
    ],
    "source_chat_placeholder": "Riassumi questa fonte per me...",
    "publish_year": "Anno di pubblicazione",
    "text": "Testo originale",
    "prompt": "Istruzione"
  },
  "blog": {
    "written_by": "Scritto da",
    "read_article": "Leggi articolo"
  },
  "stages": {
    "searching_sources": "Ricerca fonti",
    "filtering_sources": "Filtraggio fonti",
    "processing_sources": "Elaborazione fonti",
    "writing_plan": "Creazione del piano di scrittura",
    "writing_chapter": "Scrittura del capitolo"
  },
  "source": {
    "select": {
      "empty": {
        "headline": "Niente qui ancora.",
        "hint": "Puoi segnare le fonti in 'Trova fonti' e usarle in vari strumenti."
      }
    },
    "table": {
      "name": "Nome",
      "type": "Tipo",
      "created_at": "Creato il"
    },
    "type": {
      "document": "Documento",
      "website": "Articolo",
      "paper": "Articolo"
    },
    "snippet": {
      "hint": "Il testo del documento originale può essere stranamente formattato. Nella maggior parte dei casi, questo non è un problema per l'IA. Ma stiamo lavorando per migliorare questo."
    },
    "hint": {
      "not_usable": "Le fonti che non sono ancora state elaborate non vengono considerate durante la scrittura."
    },
    "processing": "in elaborazione...",
    "recent": "usato di recente",
    "bookmark": "segna",
    "bookmarked": "segnato",
    "direct_pdf_access": "Accesso diretto PDF",
    "source_info": "Informazioni sulla fonte"
  },
  "placeholders": {
    "url": "https://www.nature.com/articles/s41586-023-06447-0",
    "topic": "Sviluppo urbano sostenibile: Smart Cities tra innovazione e giustizia sociale",
    "focus_of_the_chapter_legacy": "Trasformazione digitale",
    "focus_of_the_chapter": "Come intitoleresti il tuo capitolo?",
    "outline": "I. L'evoluzione delle Smart Cities\n   A. Dalla città tradizionale alla città connessa\n      1. Definizione e concetti fondamentali\n      2. Driver tecnologici dello sviluppo\n   B. La sostenibilità come paradigma centrale\n      1. Monitoraggio e protezione ambientale\n      2. Ottimizzazione delle risorse attraverso l'IoT\nII. Dimensioni sociali della digitalizzazione\n   A. Inclusione e accessibilità\n   B. Sovranità dei dati dei cittadini\n   C. Superare il divario digitale",
    "original_text": "La fisica quantistica rivoluziona la nostra comprensione della realtà al livello più fondamentale.\nA differenza della fisica classica, dove le particelle sono particelle o onde, la meccanica quantistica mostra che la materia può avere entrambe le proprietà simultaneamente.\nIl famoso esperimento della doppia fenditura dimostra questa dualità in modo impressionante: fotoni individuali creano un pattern di interferenza come se passassero attraverso entrambe le fenditure contemporaneamente.\nL'entanglement quantistico, descritto da Einstein come 'azione spettrale a distanza', permette alle particelle di rimanere istantaneamente connesse su grandi distanze.\nQuesti fenomeni formano la base per tecnologie rivoluzionarie come i computer quantistici e la crittografia quantistica...",
    "chat": "Quali applicazioni pratiche ne derivano?",
    "report_citation": "Questa citazione è inaccurata perché...",
    "user_instruction": "Analizza l'impatto della digitalizzazione sui mestieri artigianali tradizionali e mostra approcci di soluzione",
    "topic_placeholder": "Intelligenza artificiale nell'educazione: Opportunità e sfide",
    "outline_placeholder": "I. Introduzione all'educazione supportata dall'IA\n   A. Definizione e fondamenta\n      1. Cos'è l'IA nel contesto educativo?\n      2. Sviluppi e tendenze attuali\n   B. Potenziali per l'apprendimento personalizzato\n      1. Sistemi di apprendimento adattivo\n      2. Supporto individuale\nII. Sfide e considerazioni etiche\n   A. Protezione dei dati e privacy\n   B. Divario digitale e accessibilità",
    "document_placeholder": "Ricerca_IA_Educazione.pdf",
    "article_placeholder": "https://www.nature.com/articles/s41586-023-06259-2",
    "study_program_placeholder": "Educazione digitale e pedagogia dei media",
    "study_subject_placeholder": "Umanistiche digitali",
    "interests_placeholder": "Sostenibilità, Blockchain, Economia creativa",
    "headline_placeholder": "Piattaforme di apprendimento supportate dall'IA",
    "source_chat_placeholder": "Riassumi questa fonte per me...",
    "random_text_placeholder": "Il futuro del lavoro affronta un cambiamento rivoluzionario attraverso l'integrazione dell'intelligenza artificiale e delle tecnologie di automazione.\nMentre i lavori tradizionali vengono sostituiti da robot e sistemi di IA, emergono simultaneamente campi professionali completamente nuovi e opportunità di carriera.\nLa capacità di formazione continua e adattamento alle nuove tecnologie sta diventando una competenza chiave nel mondo del lavoro moderno.\nIl lavoro remoto e i modelli di lavoro flessibili stanno guadagnando importanza e cambiando fondamentalmente come definiamo la collaborazione e la produttività.\nLe aziende devono affrontare sempre più domande di etica digitale, protezione dei dati e l'equilibrio tra efficienza e creazione di valore umano..."
  },
  "groups": {
    "research": "Ricerca",
    "essay": "Saggio",
    "misc_tools": "Altri strumenti"
  },
  "flows": {
    "summarize": {
      "headline": "Riassumi",
      "description": "Cosa vorresti riassumere?"
    },
    "titles": {
      "summarize_document": "Documento",
      "summarize_text": "Testo",
      "summarize_article": "Articolo",
      "summarize_source": "Fonte"
    },
    "prefill": {
      "summarize_document": "Riassumi il contenuto di questo documento per me."
    }
  },
  "messages": {
    "get_more_words": "Ottieni più parole ora",
    "contact_success": "Grazie per il tuo messaggio!",
    "error": "Qualcosa non ha funzionato. Per favore riprova più tardi.",
    "updated": "{field} aggiornato",
    "failed_to_update": "Impossibile aggiornare \"{field}\", per favore prova di nuovo",
    "generic_error": "La tua richiesta non è andata a buon fine – riprova più tardi o contatta il supporto 😔",
    "upload_error_generic": "Non siamo riusciti a elaborare una delle tue fonti – sostituiscila o usa le nostre fonti automatiche",
    "upload_error_url": "Non siamo riusciti a elaborare l'URL fornita – se è un PDF, prova a caricarla direttamente come file",
    "upload_error_high_no_content": "Non siamo riusciti a estrarre abbastanza informazioni rilevanti da una delle tue fonti – sostituiscila o usa le nostre fonti automatiche",
    "no_snippets_found_error": "Non sono state trovate abbastanza fonti per i dati forniti – riprova con input diversi",
    "account_deletion_error": "Non puoi eliminare il tuo account finché hai un abbonamento attivo. Disdici prima."
  },
  "validation": {
    "required": "{_field_} è un campo obbligatorio",
    "min": "{_field_} deve essere lungo almeno {length} caratteri",
    "max": "{_field_} non può superare i {length} caratteri",
    "maxarray": "{_field_} ha troppi elementi"
  },
  "domains": {
    "cancellation": {
      "headline": "Cancella abbonamento",
      "description": "Vuoi davvero cancellare il tuo abbonamento? Per quale motivo vuoi cancellare?",
      "options": [
        {
          "text": "Lavoro completato",
          "value": "work_completed"
        },
        {
          "text": "Non soddisfatto del prodotto",
          "value": "unsatisfied_with_product"
        },
        {
          "text": "Troppo costoso",
          "value": "price_performance_issue"
        },
        {
          "text": "Problemi tecnici",
          "value": "technical_issues"
        },
        {
          "text": "Trovato un altro fornitore",
          "value": "found_other_provider"
        },
        {
          "text": "Non sapevo che fosse un abbonamento",
          "value": "unaware_of_subscription"
        },
        {
          "text": "Altro",
          "value": "other"
        }
      ]
    },
    "try": {
      "headline": "Hesse Pro",
      "loading": "Stiamo attivando il tuo account di prova..."
    },
    "openai": {
      "status": {
        "unreliable": "Attualmente abbiamo un carico del server elevato. Potrebbero esserci interruzioni. Se qualcosa non funziona, per favore riprova più tardi.",
        "working_on_fix": "Potrebbero esserci interruzioni attualmente. Stiamo già lavorando su una soluzione. Per favore riprova più tardi."
      }
    },
    "ai_checker": {
      "hint": "I rilevatori di IA sono strumenti che verificano i testi per il contenuto di IA. Puoi cliccare sulle carte per andare allo strumento corrispondente."
    },
    "cookie": {
      "headline": "Cookie 🍪",
      "text1": "Quando clicchi su \"Accetta tutti i cookie\", accetti l'archiviazione di cookie sul tuo dispositivo per migliorare la navigazione del sito, analizzare l'utilizzo del sito e aiutare i nostri sforzi di marketing.",
      "analytics": "Cookie di performance",
      "analytics_text": "Questi cookie ci permettono di analizzare il comportamento degli utenti su Hesse.ai in modo anonimo per ottimizzare l'esperienza utente.",
      "marketing_text": "Questi cookie possono essere impostati dai nostri partner pubblicitari attraverso il nostro sito web. Possono essere utilizzati da quelle aziende per creare un profilo dei tuoi interessi e mostrarti annunci rilevanti su altri siti.",
      "marketing": "Cookie di marketing",
      "technical": "Cookie funzionali",
      "technical_text": "Questi cookie sono necessari per garantire un uso sicuro e affidabile.",
      "consent": "Accetta tutti i cookie",
      "save": "Salva preferenze",
      "decline": "Rifiuta"
    },
    "write": {
      "save_changes": "Salva modifiche",
      "keep_writing": "Continua a scrivere"
    },
    "feedback": {
      "title": "Dacci feedback aggiuntivo",
      "description": "Stiamo costantemente cercando di migliorare i nostri risultati. Per favore descrivi cosa vorresti che sia cambiato."
    },
    "report": {
      "title": "Segnala questa risposta?",
      "reason": "Motivo della segnalazione",
      "description": "Segnala risultati che contengono contenuto critico o illegale.",
      "result_good": "Il risultato è utile",
      "result_bad": "Il risultato non è utile"
    },
    "pricing": {
      "monthly_wordlimit": "{limit} parole al mese",
      "increase_limit": "Aumenta limite",
      "wordlimit_reached": "Hai raggiunto il tuo limite di parole",
      "wordlimit_reached_description": "La quota per questo mese è stata esaurita. Se vuoi continuare, devi aumentare il tuo limite.",
      "wordlimit_nearly_reached": "Le tue parole sono quasi esaurite.",
      "get_more_words": "Ottieni più parole",
      "get_more_words_description": "I testi di alta qualità richiedono molta potenza di calcolo. Questo è costoso.<br /> Ma abbiamo reso i nostri pacchetti il più accessibili possibile.",
      "error_title": "La prenotazione purtroppo non ha funzionato.",
      "error_description": "Contattaci - Ti aiuteremo immediatamente.",
      "text1": "Quanto sono 10.000 parole?",
      "text2": "Quello erano 10.000 parole",
      "referral_title": "Non riesci ancora a decidere?",
      "referral_title2": "Hai bisogno di più parole?",
      "referral_description": "Condividi il tuo link con gli amici. Riceverai 1.000 parole gratis per ogni nuova registrazione attraverso il tuo link."
    },
    "survey": {
      "title": "Come valuti Hesse.ai?",
      "suggestions": "Cosa cambieresti?",
      "success_title": "Grazie per il tuo feedback!",
      "success_text": "Ci aiuti a migliorare continuamente Hesse.ai",
      "abort": "non valutare"
    },
    "cards_hint": {
      "title": "Le carte di memoria sono ora disponibili",
      "subtitle": "Creare automaticamente <strong>carte di memoria</strong> dalla tua <strong>lezione</strong>?",
      "cta": "Crea carte di memoria ora"
    },
    "share_modal": {
      "headline": "Condividi Hesse - ottieni parole gratis"
    },
    "login_page": {
      "loading": "Accesso in corso...",
      "error": "L'accesso non è riuscito",
      "delayed": "L'accesso sta impiegando più tempo del solito.<br /> Per favore controlla la tua connessione internet e riprova se necessario.",
      "try_again": "Accedi di nuovo"
    },
    "sidebar": {
      "create_own_application": "Crea la tua applicazione",
      "hesse_cards": "Carte Hesse 🃏",
      "all_applications": "Tutte le applicazioni",
      "favourites": "I miei preferiti"
    },
    "profile": {
      "title": "Impostazioni del profilo",
      "limit": "Limite",
      "used_tokens": "Token utilizzati",
      "get_more_words": "Ottieni più parole ora",
      "no_subscription": "Non hai ancora un abbonamento.",
      "upgrade_now": "Aggiorna ora",
      "manage_subscription": "Gestisci abbonamento",
      "delete_account": "Elimina account",
      "deleted": "Il tuo account è stato eliminato. Se accedi, verrà creato un nuovo account."
    },
    "contact": {
      "title": "Contatto",
      "subtitle": "Contattaci"
    },
    "error_page": {
      "title404": "404 - Pagina non trovata",
      "title": "Si è verificato un errore",
      "text": "Aiutaci a migliorare Hesse.ai.<br /> Descrivi brevemente cosa hai fatto immediatamente prima che apparisse questa pagina.",
      "cta": "Vai alla pagina iniziale"
    },
    "success_page": {
      "loading": "caricamento...",
      "booking_success": "La tua prenotazione è riuscita!",
      "booked_product": "Hai prenotato {productName}",
      "start_now": "Inizia ora"
    }
  },
  "typewriter": {
    "writeEssay": [
      "Generazione di testi...",
      "Crittografia dei testi...",
      "Controllo plagio...",
      "Esecuzione strumenti di verifica IA...",
      "Testi non più tracciabili ✔"
    ],
    "writeOutline": [
      "Generazione di testi...",
      "Crittografia dei testi...",
      "Controllo plagio...",
      "Esecuzione strumenti di verifica IA...",
      "Testi non più tracciabili ✔"
    ],
    "writeIntroduction": [
      "Generazione di testi...",
      "Crittografia dei testi...",
      "Controllo plagio...",
      "Esecuzione strumenti di verifica IA...",
      "Testi non più tracciabili ✔"
    ]
  },
  "loader": [
    "Valutazione dei tuoi input",
    "Aggiunta di sale e pepe",
    "Pedro, Pedro, Pedro",
    "Scuotendo la bacchetta magica",
    "Portando al tuo tavolo"
  ],
  "features": {
    "find-sources": {
      "headline": "Trova fonti",
      "description": "Cerca fonti accademiche che potrebbero essere rilevanti per l'argomento."
    },
    "write-outline": {
      "headline": "Crea schema",
      "description": "Crea uno schema approssimativo per un argomento di lavoro accademico."
    },
    "write-chapter": {
      "headline": "Scrivi capitolo",
      "description": "Scrivi un capitolo per un lavoro accademico."
    },
    "write-essay": {
      "headline": "Scrivi saggio",
      "description": "Scrivi un lavoro accademico."
    },
    "source-qa": {
      "headline": "Chat delle fonti",
      "description": "Rispondi a domande su una fonte. Aggiungi un link a un sito web o carica un file dal tuo computer."
    },
    "proofreading": {
      "headline": "Correzione",
      "description": "Correggi un testo."
    }
  }
}
